export const API_URL = process.env.VUE_APP_BASE_API_URL;
export const WEB_URL = process.env.VUE_APP_BASE_WEB_URL;

export const SERVICE_API_URL = "/api";

export const VERSION = 1;
export const VERSION_CODE = "0.0.1";
